<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-18 mb-12 px-4 xl:px-0">
        <div>
            <h2 v-html="headers.title" class="text-center mx-auto max-w-6xl text-2xl sm:text-3xl lg:text-4xl font-medium mb-10">
               
            </h2>
            <p class="text-base px-2 sm:text-lg md:text-xl text-center">
                {{ headers.description }}
            </p>
            <div class="mt-12 gap-4 grid grid-cols-12">
                <div v-for="d in data" class="xl:col-span-3 md:col-span-6 col-span-12">
                    <div class="flex flex-col h-full border p-4 border-gray-200 ">
                        <h3 class="font-semibold text-xl sm:text-2xl sm:mb-6 mb-4 mt-3">{{ d.title }}</h3>
                        <p>{{ d.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import FunctionalLocale from '~~/config/widgets/functional-component';

const functionals = (new FunctionalLocale())
const data = functionals.data
const headers = functionals.header
</script>